import React, { Component } from 'react';

import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import classnames from 'classnames';
import { reloadBoard } from 'common/actions/boards';
import { reloadCustomPostFields } from 'common/actions/customPostFields';
import { reloadConfiguration as reloadIdeasConfiguration } from 'common/actions/ideasConfiguration';
import { reloadPost } from 'common/actions/posts';
import { reloadRoadmapPostsForRoadmapsWithPost } from 'common/actions/roadmapPosts';
import AJAX from 'common/AJAX';
import { SortableList, SortableListItemHandle } from 'common/common/SortableList';
import Tooltip from 'common/common/Tooltip';
import VideoNUX from 'common/common/VideoNUX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { OpenModalContext } from 'common/containers/ModalContainer';
import { ShowToastContext, ToastTypes } from 'common/containers/ToastContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import connect from 'common/core/connect';
import { CustomFieldTypes } from 'common/customPostFields/Constants';
import CopyButtonV2 from 'common/inputs/CopyButtonV2';
import Link from 'common/Link';
import AccessModal from 'common/modals/AccessModal';
import EditableCustomPostField from 'common/post/EditableCustomPostField';
import MovePostDropdown from 'common/post/MovePostDropdown';
import PostCategoryDropdown from 'common/post/PostCategoryDropdown';
import PostCategoryMenu from 'common/post/PostCategoryMenu';
import PostETAInput from 'common/post/PostETAInput';
import PostOwnerInput from 'common/post/PostOwnerInput';
import PostStatusDropdown from 'common/post/PostStatusDropdown';
import PostVoteAsForm from 'common/post/PostVoteAsForm';
import VotersFacepile from 'common/post/VotersFacepile';
import AdminAsanaPostSidebarSection from 'common/subdomain/admin/AdminAsanaPostSidebarSection';
import AdminAzureDevopsPostSidebarSection from 'common/subdomain/admin/AdminAzureDevopsPostSidebarSection';
import AdminLinearPostSidebarSection from 'common/subdomain/admin/AdminLinearPostSidebarSection';
import Tag from 'common/tags/Tag';
import TagSelector from 'common/tags/TagSelector';
import Tappable from 'common/Tappable';
import Button from 'common/uiV3/Button';
import HStack from 'common/uiV3/HStack';
import TooltipV3 from 'common/uiV3/Tooltip';
import getCannyOrigin from 'common/util/getCannyOrigin';
import hasPermission from 'common/util/hasPermission';
import mapify from 'common/util/mapify';
import numberWithCommas from 'common/util/numberWithCommas';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';
import withContexts from 'common/util/withContexts';
import VideoThumbnailVote from 'img/video-thumbnail-vote.jpg';
import { Settings } from 'lucide-react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import AdminClickupPostSidebarSection from './AdminClickupPostSidebarSection';
import AdminFeedbackVotersModal from './AdminFeedbackVotersModal';
import AdminGitHubPostSidebarSection from './AdminGitHubPostSidebarSection';
import AdminIdeaPostSidebarSection from './AdminIdeaPostSidebarSection';
import AdminJiraPostSidebarSection from './AdminJiraPostSidebarSection';
import AdminRoadmapsPostSidebarSection from './AdminRoadmapsPostSidebarSection';
import AdminSidebarSection from './AdminSidebarSection';

import 'css/components/subdomain/admin/_AdminPostSidebar.scss';

const Modals = {
  opportunities: 'OpportunitiesModal',
  voters: 'VotersModal',
};

class AdminPostSidebar extends Component {
  static propTypes = {
    board: PropTypes.shape({
      name: PropTypes.string,
      urlName: PropTypes.string,
    }),
    boards: PropTypes.array,
    company: PropTypes.shape({
      subdomain: PropTypes.string,
    }),
    customPostFields: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    openModal: PropTypes.func,
    post: PropTypes.shape({
      status: PropTypes.string,
      voters: PropTypes.array,
    }),
    roadmaps: PropTypes.array,
    viewer: PropTypes.object,
  };

  state = {
    isReorderingUnlinkedFields: false,
    modal: null,
    reorderedUnlinkedFields: null,
    tagsFormOpen: false,
    tagsLoading: [],
    voterFormOpen: false,
  };

  constructor(props, context) {
    super(props, context);

    this.tagSelectorRef = React.createRef();
  }

  isAllowedRoadmapAccess() {
    const { company, viewer } = this.props;
    if (company.postCount === 0) {
      return false;
    } else if (!hasPermission('manageRoadmap', company, viewer)) {
      return false;
    }

    return company.features.prioritizationRoadmap;
  }

  onCategorySelected = async (category) => {
    const { post, reloadPost } = this.props;
    await AJAX.post('/api/posts/changeCategory', {
      categoryID: category ? category._id : null,
      postID: post._id,
    });
    reloadPost(post);
  };

  onShowOpportunitiesModal = () => {
    this.setState({ modal: Modals.opportunities });
  };

  onShowVotersModal = () => {
    this.setState({ modal: Modals.voters });
  };

  onTagSelectorFocus = () => {
    const { company, openModal, viewer } = this.props;
    if (hasPermission('changePostTags', company, viewer)) {
      return;
    }

    openModal(AccessModal, {
      requiredPermissions: ['changePostTags'],
    });
    setTimeout(() => {
      this.tagSelectorRef.current.blur();
    }, 0);
  };

  onToggleTag = (tag) => {
    const { company, openModal, viewer } = this.props;
    if (!hasPermission('changePostTags', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['changePostTags'],
      });
      return;
    }

    const { tagsLoading } = this.state;
    if (tagsLoading.includes(tag._id)) {
      return;
    }

    this.setState({
      tagsLoading: tagsLoading.concat([tag._id]),
    });

    const { post, reloadPost } = this.props;
    const postTags = this.props.post.tags;
    if (
      postTags.some((postTag) => {
        return postTag._id === tag._id;
      })
    ) {
      AJAX.post(
        '/api/posts/removeTag',
        {
          postID: post._id,
          tagID: tag._id,
        },
        (response) => {
          reloadPost(post).then(() => {
            this.setState({
              tagsLoading: this.state.tagsLoading.filter((t) => t !== tag._id),
            });
          });
        },
      );
    } else {
      AJAX.post(
        '/api/posts/addTag',
        {
          postID: post._id,
          tagID: tag._id,
        },
        (response) => {
          reloadPost(post).then(() => {
            this.setState({
              tagsLoading: this.state.tagsLoading.filter((t) => t !== tag._id),
            });
          });
        },
      );
    }
  };

  onUpdatePostField = async (value, customPostField) => {
    const { post, reloadPost } = this.props;

    const existingCustomFields = post.customPostFields.reduce((acc, field) => {
      acc[field._id] = field.value;
      return acc;
    }, {});

    await AJAX.post('/api/posts/edit', {
      customFieldValuesMap: {
        ...existingCustomFields,
        [customPostField._id]: value,
      },
      details: post.details,
      fileURLs: JSON.stringify(post.fileURLs || []),
      imageURLs: JSON.stringify(post.imageURLs || []),
      postID: post._id,
      title: post.title,
    });

    await reloadPost(post);
  };

  getUnlinkedFields = () => {
    const {
      board: { boardFields },
      company,
      customPostFields,
      post,
    } = this.props;

    if (!customPostFields?.length) {
      return [];
    }

    const boardFieldMap = mapify(boardFields, 'customPostFieldID');
    const postFieldMap = mapify(post.customPostFields, '_id');
    const doesPlanSupport = company.features?.customPostFields ?? false;

    return customPostFields.filter((customPostField) => {
      const isInBoardForm = boardFieldMap[customPostField._id];
      if (isInBoardForm) {
        return false;
      }
      const value = postFieldMap[customPostField._id]?.value;
      if (!doesPlanSupport && !value) {
        return false;
      }
      const fullType = CustomFieldTypes[customPostField.type];
      if (!fullType) {
        return false;
      }
      return true;
    });
  };

  onToggleReorderingUnlinkedFields = () => {
    const { isReorderingUnlinkedFields } = this.state;

    if (isReorderingUnlinkedFields) {
      this.setState({
        isReorderingUnlinkedFields: false,
        reorderedUnlinkedFields: null,
      });
    } else {
      this.setState({
        isReorderingUnlinkedFields: true,
        reorderedUnlinkedFields: this.getUnlinkedFields(),
      });
    }
  };

  onReorderUnlinkedFieldsChanged = (reorderedFields) => {
    this.setState({ reorderedUnlinkedFields: reorderedFields });
  };

  onSaveUnlinkedFieldsOrder = async () => {
    const { reorderedUnlinkedFields } = this.state;
    const { showToast, reloadCustomPostFields, reloadIdeasConfiguration } = this.props;

    const fieldIDs = reorderedUnlinkedFields.map((field) => field._id);
    const response = await AJAX.post('/api/ideas/fields/reorder', { fieldIDs });

    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
    });

    if (error) {
      showToast(error.message, ToastTypes.error);
    } else {
      this.setState({
        isReorderingUnlinkedFields: false,
      });
      reloadCustomPostFields();
      reloadIdeasConfiguration();
    }
  };

  onToggleTagsForm = () => {
    this.setState(({ tagsFormOpen }) => ({
      tagsFormOpen: !tagsFormOpen,
    }));
  };

  onToggleVotersForm = () => {
    const { company, openModal, viewer } = this.props;
    if (!hasPermission('voteOnBehalf', company, viewer)) {
      openModal(AccessModal, {
        requiredPermissions: ['voteOnBehalf'],
      });
      return;
    }

    this.setState({
      voterFormOpen: !this.state.voterFormOpen,
    });
  };

  renderBoard() {
    const {
      company: { boardCount },
    } = this.props;
    if (boardCount <= 1) {
      return null;
    }

    return (
      <div className="postDetail">
        <div className="detailLabel">Board</div>
        {this.renderMovePostDropdown()}
      </div>
    );
  }

  renderUnlinkedPostFieldsAction() {
    const { isReorderingUnlinkedFields, reorderedUnlinkedFields } = this.state;

    if (!isReorderingUnlinkedFields) {
      return (
        <TooltipV3>
          <TooltipV3.Trigger asChild>
            <div>
              <Button
                variant="plain"
                size="small"
                iconOnly
                onClick={this.onToggleReorderingUnlinkedFields}>
                <Settings className="size-4" />
              </Button>
            </div>
          </TooltipV3.Trigger>
          <TooltipV3.Content>Rearrange fields</TooltipV3.Content>
        </TooltipV3>
      );
    }

    const unlinkedFields = this.getUnlinkedFields();

    const hasOrderChanged =
      reorderedUnlinkedFields &&
      unlinkedFields.length === reorderedUnlinkedFields.length &&
      unlinkedFields.some((field, index) => field._id !== reorderedUnlinkedFields[index]?._id);

    return (
      <HStack className="items-center gap-2">
        <Button size="small" variant="outlined" onClick={this.onToggleReorderingUnlinkedFields}>
          Cancel
        </Button>
        <Button size="small" disabled={!hasOrderChanged} onClick={this.onSaveUnlinkedFieldsOrder}>
          Save
        </Button>
      </HStack>
    );
  }

  renderCustomPostField = (customPostField, { handleProps, style, ref, showDragHandle } = {}) => {
    const { company, post } = this.props;
    const postFieldMap = mapify(post.customPostFields, '_id');
    const doesPlanSupport = company.features?.customPostFields ?? false;
    const value = postFieldMap[customPostField._id]?.value;
    const fullType = CustomFieldTypes[customPostField.type];

    return (
      <div ref={ref} style={style} className="postDetail customField" key={customPostField._id}>
        <div className="flex items-center gap-2 self-center">
          {showDragHandle && <SortableListItemHandle handleProps={handleProps} />}
          <Tooltip
            position="top"
            containerClassName="detailLabel"
            delay={1000}
            value={customPostField.name}>
            <label htmlFor={customPostField._id}>{customPostField.name}</label>
          </Tooltip>
        </div>
        <div className="detailValue">
          <EditableCustomPostField
            key={customPostField._id}
            customPostField={{
              ...customPostField,
              placeholder: fullType.hasOptions ? '—' : null,
              value,
            }}
            onSubmit={this.onUpdatePostField}
            showUpsell={!doesPlanSupport}
          />
        </div>
      </div>
    );
  };

  renderUnlinkedPostFields() {
    const { isReorderingUnlinkedFields, reorderedUnlinkedFields } = this.state;
    const unlinkedFields = this.getUnlinkedFields();

    if (unlinkedFields.length === 0) {
      return null;
    }

    const displayFields = reorderedUnlinkedFields ?? unlinkedFields;

    if (!isReorderingUnlinkedFields) {
      return displayFields.map((customPostField) => this.renderCustomPostField(customPostField));
    }

    const SortableFieldItem = React.forwardRef(({ item, handleProps, style }, ref) => {
      return this.renderCustomPostField(item, { handleProps, style, ref, showDragHandle: true });
    });

    return (
      <SortableList
        items={displayFields}
        onItemsChanged={this.onReorderUnlinkedFieldsChanged}
        getId={(field) => field._id}
        ItemComponent={SortableFieldItem}
        dndContextProps={{
          modifiers: [restrictToVerticalAxis],
        }}
      />
    );
  }

  renderCategoryOption() {
    const { board, post } = this.props;
    const settingsURL = `/admin/settings/boards/${board.urlName}/categories`;

    if (!board?.categories || board.categories.length === 0) {
      return (
        <div className="postDetail">
          <div className="detailLabel">Category</div>
          <Link to={settingsURL}>
            <div className="detailValue toggleButton">Add</div>
          </Link>
        </div>
      );
    }

    if (board.categories.length < 3) {
      return (
        <div className="postDetail">
          <div className="detailLabel">Category</div>
          <div className="detailValue">
            <PostCategoryDropdown post={post} board={board} />
          </div>
        </div>
      );
    }

    const categoryName = post?.category?.name;
    return (
      <div className="postDetail">
        <div className="detailLabel">Category</div>
        <div className="detailValue">
          <PostCategoryMenu board={board} onCategorySelected={this.onCategorySelected}>
            <div className="categorySelectorTrigger">
              <div className={classnames('categoryName', { selected: !!categoryName })}>
                {categoryName || 'Uncategorized'}
              </div>
              <div className="icon-chevron-down" />
            </div>
          </PostCategoryMenu>
        </div>
      </div>
    );
  }

  renderETADetail() {
    const { post, reloadPost } = this.props;
    return (
      <div className="postDetail">
        <PostETAInput post={post} reloadPost={reloadPost} />
      </div>
    );
  }

  renderMovePostDropdown() {
    const { boards, post, board: currentBoard } = this.props;
    return (
      <div className="movePost detailValue">
        <MovePostDropdown board={currentBoard} boards={boards} post={post} />
      </div>
    );
  }

  renderOpportunitiesSection() {
    const { post } = this.props;
    if (!post.opportunities?.length) {
      return null;
    }

    const { opportunities } = post;
    const header =
      opportunities.length > 1 ? `${opportunities.length} Opportunities` : `1 Opportunity`;

    const value = opportunities.reduce((prev, opportunity) => {
      if (!opportunity.value) {
        return prev;
      }
      return prev + opportunity.value;
    }, 0);

    return (
      <AdminSidebarSection className="opportunities" title={header}>
        <Tappable onTap={this.onShowOpportunitiesModal}>
          <div className="opportunityValue">${numberWithCommas(value)} total value</div>
        </Tappable>
      </AdminSidebarSection>
    );
  }

  renderOwner() {
    const { post, reloadPost } = this.props;
    return (
      <div className="postDetail">
        <PostOwnerInput post={post} reloadPost={reloadPost} />
      </div>
    );
  }

  renderPostDetails() {
    const { board, company, post } = this.props;
    const hasUnlinkedFields = this.hasUnlinkedFields();

    return (
      <AdminSidebarSection
        className="postDetails"
        title="Details"
        action={hasUnlinkedFields ? this.renderUnlinkedPostFieldsAction() : null}>
        {this.renderPublicLink()}
        {this.renderBoard()}
        <div className="postDetail">
          <PostStatusDropdown
            board={board}
            // if a company downgrades, they might still have custom statuses in the DB
            // hide them so posts can't be assigned to custom default statuses
            showCustomStatuses={company.features.customStatuses}
            post={post}
          />
        </div>
        {this.renderOwner()}
        {this.renderETADetail()}
        {this.renderCategoryOption()}
        {this.renderUnlinkedPostFields()}
      </AdminSidebarSection>
    );
  }

  hasUnlinkedFields() {
    return this.getUnlinkedFields().length > 0;
  }

  renderPublicLink() {
    const { board, company, post } = this.props;
    const toURL = `/${board.urlName}/p/${post.urlName}`;
    const widgetURL = board?.settings?.widgetURL;
    const boardURL = widgetURL || `${getCannyOrigin(company)}/${board.urlName}`;
    const publicURL = `${boardURL}/p/${post.urlName}`;

    return (
      <div className="postDetail">
        <div className="detailLabel">Public link</div>
        <Link className="publicLink detailValue" to={toURL}>
          {publicURL}
        </Link>
        <CopyButtonV2 className="customPostFieldIcon" value={publicURL} />
      </div>
    );
  }

  renderPostTags() {
    const boardTags = this.props.board.tags;
    const postTags = this.props.post.tags;

    if (this.props.post.error) {
      return null;
    }

    const postTagsSet = {};
    postTags.forEach((postTag) => {
      postTagsSet[postTag._id] = true;
    });

    const { tagsLoading } = this.state;
    const tagButtons = [];
    boardTags
      .filter((boardTag) => {
        return postTagsSet[boardTag._id] || tagsLoading.includes(boardTag._id);
      })
      .forEach((boardTag) => {
        tagButtons.push(
          <Tag
            key={boardTag._id}
            loading={this.state.tagsLoading.includes(boardTag._id)}
            name={boardTag.name}
            onTap={this.onToggleTag.bind(this, boardTag)}
            selected={true}
          />,
        );
      });

    if (tagButtons.length === 0) {
      return null;
    }

    return <div className="tagButtons">{tagButtons}</div>;
  }

  renderTagsAction = () => {
    return (
      <Tappable onTap={this.onToggleTagsForm}>
        <div>Add tags</div>
      </Tappable>
    );
  };

  renderTagsForm() {
    const { tagsFormOpen, tagsLoading } = this.state;
    const { board, company, post, reloadBoard, viewer } = this.props;

    if (post.error) {
      return null;
    }

    const excludeTags = post.tags.concat(tagsLoading);

    if (!tagsFormOpen) {
      return null;
    }

    return (
      <TagSelector
        boards={[board]}
        excludeTags={excludeTags}
        allowTagCreation={hasPermission('manageTags', company, viewer)}
        onFocus={this.onTagSelectorFocus}
        onTagSelected={this.onToggleTag}
        onTagCreated={async (tag) => {
          await reloadBoard(board.urlName);
          this.onToggleTag(tag);
        }}
        placeholder="Add tag"
        ref={this.tagSelectorRef}
      />
    );
  }

  renderTags() {
    return (
      <AdminSidebarSection action={this.renderTagsAction()} className="postTags" title="Tags">
        {this.renderTagsForm()}
        {this.renderPostTags()}
      </AdminSidebarSection>
    );
  }

  renderVotersAction() {
    return (
      <Tappable onTap={this.onToggleVotersForm}>
        <div>Add voter</div>
      </Tappable>
    );
  }

  renderVotersForm() {
    if (!this.state.voterFormOpen) {
      return null;
    }

    const { board, post } = this.props;
    return <PostVoteAsForm post={post} board={board} />;
  }

  renderVoters() {
    const { post } = this.props;
    return (
      <Tappable onTap={this.onShowVotersModal}>
        <div>
          <VotersFacepile post={post} voters={post.voters} />
        </div>
      </Tappable>
    );
  }

  renderIdeaSection() {
    const { company, post } = this.props;
    const isIDBEnabled = company?.featureAllowlist?.includes('idea-database');

    if (!isIDBEnabled) {
      return null;
    }

    return <AdminIdeaPostSidebarSection post={post} />;
  }

  renderVotersSection() {
    const { post } = this.props;
    const votersHeader = `${post.score} Voter${post.score === 1 ? '' : 's'}`;

    return (
      <AdminSidebarSection
        action={this.renderVotersAction()}
        className="voters"
        title={votersHeader}>
        {this.renderVotersForm()}
        <VideoNUX
          name="voteBehalf"
          text="Vote on behalf of your&nbsp;users"
          videoThumbnail={VideoThumbnailVote}
          videoURL="https://www.loom.com/embed/4248837682a94aacb22d455b8d1c4e09?autoplay=1"
        />
        {this.renderVoters()}
      </AdminSidebarSection>
    );
  }

  renderAsanaSection() {
    const { post } = this.props;
    return <AdminAsanaPostSidebarSection post={post} />;
  }

  renderAzureDevopsSection() {
    const { post } = this.props;
    return <AdminAzureDevopsPostSidebarSection post={post} />;
  }

  renderClickupSection() {
    const { post } = this.props;
    return <AdminClickupPostSidebarSection post={post} />;
  }

  renderGitHubSection() {
    const { board, post } = this.props;

    return <AdminGitHubPostSidebarSection board={board} post={post} />;
  }

  renderJiraSection() {
    const { board, post } = this.props;
    return <AdminJiraPostSidebarSection board={board} post={post} />;
  }

  renderLinearSection() {
    const { post } = this.props;
    return <AdminLinearPostSidebarSection post={post} />;
  }

  renderRoadmapsSection() {
    const { post, roadmaps } = this.props;
    if (!this.isAllowedRoadmapAccess()) {
      return null;
    }

    return <AdminRoadmapsPostSidebarSection post={post} roadmaps={roadmaps} />;
  }

  renderModal() {
    const { post } = this.props;
    const { modal } = this.state;

    if (modal === Modals.voters) {
      return (
        <AdminFeedbackVotersModal
          defaultOption="voters"
          onClose={() => this.setState({ modal: null })}
          post={post}
        />
      );
    } else if (modal === Modals.opportunities) {
      return (
        <AdminFeedbackVotersModal
          defaultOption="opportunities"
          onClose={() => this.setState({ modal: null })}
          post={post}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className="adminPostSidebar">
        {this.renderPostDetails()}
        {this.renderIdeaSection()}
        {this.renderTags()}
        {this.renderVotersSection()}
        {this.renderOpportunitiesSection()}
        {this.renderRoadmapsSection()}
        {this.renderAsanaSection()}
        {this.renderClickupSection()}
        {this.renderGitHubSection()}
        {this.renderJiraSection()}
        {this.renderLinearSection()}
        {this.renderAzureDevopsSection()}
        {this.renderModal()}
      </div>
    );
  }
}

export default compose(
  connect(null, (dispatch) => ({
    reloadPost: (post) => {
      return Promise.all([
        dispatch(reloadRoadmapPostsForRoadmapsWithPost(post)),
        dispatch(reloadPost(post)),
      ]);
    },
    reloadBoard: (boardURLName) => {
      return dispatch(reloadBoard(boardURLName));
    },
    reloadCustomPostFields: () => {
      return dispatch(reloadCustomPostFields());
    },
    reloadIdeasConfiguration: () => {
      return dispatch(reloadIdeasConfiguration());
    },
  })),
  withContexts(
    {
      company: CompanyContext,
      openModal: OpenModalContext,
      showToast: ShowToastContext,
      viewer: ViewerContext,
    },
    {
      forwardRef: true,
    },
  ),
)(AdminPostSidebar);
